import React from 'react'

const UtilityToolbarHeader: React.FC<React.PropsWithChildren> = (
  props,
): React.ReactElement => {
  return <div>{props.children}</div>
}

export default UtilityToolbarHeader
